import React from "react";

export const IconOption5 = () => {
  return (
    <svg
      width="14"
      height="20"
      viewBox="0 0 14 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.42841 2.30957C4.80281 2.30957 2.6665 4.44588 2.6665 7.07148C2.6665 9.69707 4.80281 11.8334 7.42841 11.8334C10.054 11.8334 12.1903 9.69707 12.1903 7.07148C12.1903 4.44588 10.054 2.30957 7.42841 2.30957ZM9.72365 6.78814L8.78734 7.74856L9.00906 9.10689C9.02752 9.21939 8.9796 9.33249 8.88674 9.39826C8.83555 9.43398 8.77514 9.45243 8.71502 9.45243C8.66561 9.45243 8.61591 9.44023 8.57097 9.41523L7.42781 8.78308L6.28466 9.41523C6.18466 9.47058 6.06204 9.46374 5.96888 9.39796C5.87573 9.33219 5.82811 9.21909 5.84656 9.10659L6.06829 7.74826L5.13198 6.78784C5.054 6.70778 5.02722 6.59142 5.06293 6.48546C5.09865 6.37951 5.19002 6.30273 5.30014 6.28576L6.58258 6.08993L7.15877 4.86284C7.20787 4.75808 7.31293 4.69171 7.42811 4.69171C7.54329 4.69171 7.64835 4.75838 7.69746 4.86284L8.27365 6.08993L9.55609 6.28576C9.66621 6.30273 9.75787 6.37951 9.79329 6.48546C9.82871 6.59142 9.80162 6.70808 9.72365 6.78814Z"
        fill="#F2F2F2"
      />
      <path
        d="M7.42848 0.523926C3.81806 0.523926 0.880859 3.46113 0.880859 7.07154C0.880859 10.682 3.81806 13.6192 7.42848 13.6192C11.0389 13.6192 13.9761 10.682 13.9761 7.07154C13.9761 3.46113 11.0389 0.523926 7.42848 0.523926ZM7.42848 12.4287C4.47461 12.4287 2.07134 10.0254 2.07134 7.07154C2.07134 4.11768 4.47461 1.7144 7.42848 1.7144C10.3823 1.7144 12.7856 4.11768 12.7856 7.07154C12.7856 10.0254 10.3823 12.4287 7.42848 12.4287Z"
        fill="#F2F2F2"
      />
      <path
        d="M7.8015 6.48697L7.42739 5.68994L7.05328 6.48697C7.01102 6.57714 6.9268 6.63994 6.82888 6.65453L5.96191 6.78697L6.59912 7.43994C6.66519 7.5078 6.69495 7.60244 6.67977 7.6956L6.53245 8.59708L7.28305 8.18191C7.32799 8.1572 7.37739 8.1447 7.42709 8.1447C7.4768 8.1447 7.5262 8.1572 7.57114 8.18191L8.32174 8.59708L8.17441 7.6956C8.15924 7.60244 8.1893 7.5075 8.25507 7.43994L8.89227 6.78697L8.0259 6.65482C7.92799 6.63994 7.84346 6.57714 7.8015 6.48697Z"
        fill="#F2F2F2"
      />
      <path
        d="M10.4043 19.2735L10.6424 19.452C10.7477 19.5309 10.873 19.5711 10.9995 19.5711C11.0903 19.5711 11.1814 19.5506 11.2659 19.5083C11.4674 19.4074 11.5948 19.2015 11.5948 18.9759V12.8711C11.223 13.1384 10.8248 13.3711 10.4043 13.564V19.2735Z"
        fill="#F2F2F2"
      />
      <path
        d="M5.04736 13.8066V18.8278L7.42832 17.0421L9.80927 18.8278V13.8066C9.06433 14.07 8.26343 14.2147 7.42832 14.2147C6.5932 14.2147 5.7923 14.07 5.04736 13.8066Z"
        fill="#F2F2F2"
      />
      <path
        d="M3.26172 18.9759C3.26172 19.2015 3.3891 19.4074 3.59059 19.5083C3.67481 19.5506 3.76589 19.5711 3.85636 19.5711C3.98315 19.5711 4.10874 19.5306 4.2141 19.452L4.45219 19.2735V13.564C4.03166 13.3711 3.63344 13.1384 3.26172 12.8711V18.9759Z"
        fill="#F2F2F2"
      />
    </svg>
  );
};
